/**
 * 通用按需模块加载器
 */

export function createLazyModuleLoader(config = {}) {
  const {
    importWithChunkRecovery = (loader) => loader(),
    importer = async () => ({}),
    getApi = () => null,
    setApi = () => {},
    getLoadingPromise = () => null,
    setLoadingPromise = () => {}
  } = config;

  return async function loadModule() {
    const currentApi = getApi();
    if (currentApi) return currentApi;

    const currentLoadingPromise = getLoadingPromise();
    if (currentLoadingPromise) return currentLoadingPromise;

    const loadingPromise = importWithChunkRecovery(() => importer())
      .then((mod) => {
        setApi(mod);
        return mod;
      })
      .finally(() => {
        setLoadingPromise(null);
      });

    setLoadingPromise(loadingPromise);
    return loadingPromise;
  };
}
